import Wrapper from './wrapper';
import { IWrapper } from './types';

import { DataTypesAPIResponse } from '../components/fields/FieldsSettings/FieldsSettingsTypes';

class DataTypes {
  wrapper: IWrapper;
  /**
   * @param {Wrapper} wrapper
   */
  constructor(wrapper: Wrapper) {
    this.wrapper = wrapper;
  }

  retrieve() {
    return this.wrapper.client.get<DataTypesAPIResponse[], DataTypesAPIResponse[]>(
      `data-types/?advanced=true`
    );
  }
}

export default DataTypes;
